<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      title="Danh sách ca tham vấn"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="slots"
        :page.sync="page"
        :loading="loading"
        :items-per-page="perPage"
        item-key="_id"
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
        :item-class="() => 'slot-row'"
        @click:row="rowClick"
      >
        <template v-slot:[`item.user.name`]="{ item }">
          <div>
            <v-avatar size="36" class="elevation-2">
              <img
                alt="Avatar"
                :src="item.user.avatar || require('@/assets/face.jpg')"
              />
            </v-avatar>
            <span class="ml-5">{{ item.user.name }}</span>
          </div>
        </template>
        <template v-slot:[`item.startTime`]="{ item }">
          {{ formatDate(item.startTime) }}
        </template>
        <template v-slot:[`item.price`]="{ item }">
          {{ formatMoney(item.price) }}
        </template>
        <template v-slot:[`item.booker.name`]="{ item }">
          <div v-if="item.booker">
            <v-avatar size="36" class="elevation-2">
              <img
                alt="Avatar"
                :src="item.booker.avatar || require('@/assets/face.jpg')"
              />
            </v-avatar>
            <span class="ml-5">{{ item.booker.name }}</span>
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div :class="item.booker ? 'green--text' : 'grey--text'">
            {{ item.booker ? "Đã đặt lịch" : "Chưa đặt lịch" }}
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import BookingSlotApi from "@/api/BookingSlotApi";
export default {
  data() {
    return {
      headers: [
        {
          text: "Người đặt lịch",
          align: "start",
          sortable: false,
          value: "booker.name"
        },
        { text: "Thời gian bắt đầu", value: "startTime" },
        { text: "Giá tiền", value: "price" },
        { text: "Trạng thái", value: "status" }
      ],
      page: 1,
      perPage: 10,
      totalPages: 0,
      slots: [],
      loading: true,
      loadingUpdate: false
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await BookingSlotApi.myPastBookingSlots();
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.slots = data;
        this.totalPages = Math.ceil(data.length / this.perPage);
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("vi");
    },

    formatMoney(money) {
      return money ? `${money.toLocaleString("vi")} đ` : "?";
    },

    historyStatus(status) {
      return {
        booked: "Đặt lịch",
        canceled: "Huỷ lịch"
      }[status];
    },

    async goToPage(page) {
      this.page = page;
    },

    rowClick(slot) {
      this.$router.push(`/psychology/booking-slots/${slot._id}`);
    }
  }
};
</script>
<style lang="sass">
.slot-row
  cursor: pointer
</style>
